import type { AnchorProps } from "@mantine/core";
import { Anchor, Group } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import type { FC, PropsWithChildren } from "react";
import type { RoutePath } from "../App";
import { IconArrowLeft } from "@tabler/icons-react";

type Props = AnchorProps & PropsWithChildren & {
  href: string;
  onClick?: () => void;
};

export const RelativeLink: FC<Props> = ({ children, href, onClick, ...rest }) => {
  const navigate = useNavigate();

  return (
    <Anchor
      {...rest}
      onClick={() => {
        onClick?.();
        void navigate({ to: href });
      }}
    >
      {children}
    </Anchor>
  );
};

type PropsLink = AnchorProps & PropsWithChildren & {
  href: RoutePath;
  onClick?: () => void;
  search?: object;
};

export const Link: FC<PropsLink> = ({ children, href, onClick, ...rest }) => {
  const navigate = useNavigate();

  return (
    <Anchor
      {...rest}
      onClick={() => {
        onClick?.();
        void navigate({ to: href });
      }}
    >
      {children}
    </Anchor>
  );
};

export const LinkBack: FC<PropsLink> = ({ children, href, onClick, search, ...rest }) => {
  const navigate = useNavigate();

  return (
    <Anchor
      {...rest}
      onClick={() => {
        onClick?.();
        void navigate({ to: href, search: search });
      }}
    >
      <Group gap="0px" component="span">
        <IconArrowLeft size="16px" />
        {" "}
        {children}
      </Group>
    </Anchor>
  );
};
